import { render, staticRenderFns } from "./BankIDLogin.vue?vue&type=template&id=4857d177&scoped=true"
import script from "./BankIDLogin.vue?vue&type=script&lang=js"
export * from "./BankIDLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857d177",
  null
  
)

export default component.exports